import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class GeneralService {
  constructor() {}

  checkPasswordLength(password: string) {
    if (password.length >= 8) return true;
    return false;
  }

  checkPasswordAlphaNum(password: string) {
    if (password.match(/[A-z]/) && password.match(/[\d]/)) return true;
    return false;
  }

  checkPasswordMatch(password: string, confirmPassword: string) {
    if (password === confirmPassword) return true;
    return false;
  }

  validateStartDate(date: any, message: string | null) {
    if (date === null || date === "") return message;

    let start_date_input = new Date(date);
    let localTimeZoneOffset =
      Math.abs(new Date().getTimezoneOffset()) * 60 * 1000;

    start_date_input.getTime() - localTimeZoneOffset <= new Date().getTime()
      ? (message = null)
      : (message = "start date should be lessthan or equal current date");

    message === null &&
    start_date_input.getTime() < 1546304400000 - localTimeZoneOffset
      ? (message =
          "start date before " +
          new Date(1546304400000).toLocaleDateString().toLowerCase() +
          " are not allowed")
      : (message = null);

    return message;
  }

  validateEndDate(date: any, message: string | null, start_date: any) {
    if (date === null || date === "") return message;

    let end_date_input = new Date(date);
    let localTimeZoneOffset =
      Math.abs(new Date().getTimezoneOffset()) * 60 * 1000;

    end_date_input.getTime() - localTimeZoneOffset <= new Date().getTime()
      ? (message = null)
      : (message = "end date should be lessthan or equal current date");

    if (message === null && start_date !== null && start_date !== "") {
      new Date(start_date).getTime() > end_date_input.getTime()
        ? (message = "start date should not be greater than end date")
        : (message = null);
    }

    return message;
  }
}
